import { Box, Card, CardContent, Grid } from '@mui/material';

const SummaryCard = ({ title = '', summaryContent = [] }) => (
  <Grid item xs={12} md={6}>
    {title}
    <Card sx={{ mt: '1rem' }}>
      <Box
        sx={{
          textAlign: 'left',
          width: '100%',
          bgcolor: 'background.paper',
          position: 'relative',
          overflow: 'auto',
          maxHeight: 300,
          '& ul': { padding: 0 },
        }}
      >
        <CardContent>{summaryContent}</CardContent>
      </Box>
    </Card>
  </Grid>
);

export default SummaryCard;
